<template>
    <div class="how-it-works-area how-it-works-bg section-space--pb_120">
        <div class="container-fluid container-fluid--cp-150">
            <div class="row align-items-center">
                <div class="col-lg-6 video-popup video-link">
                    <silentbox-single src="https://www.youtube.com/watch?v=9No-FiEInLA">
                        <div class="single-popup-wrap">
                            <img class="img-fluid" src="../../assets/img/agency/poster-image-01.jpg" alt="">
                            <div class="ht-popup-video video-button video-overlay">
                                <div class="video-mark">
                                    <div class="wave-pulse wave-pulse-1"></div>
                                    <div class="wave-pulse wave-pulse-2"></div>
                                </div>
                                <div class="video-button__five">
                                    <div class="video-play">
                                        <span class="video-play-icon"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </silentbox-single>
                </div>
                <div class="col-lg-6">
                    <div class="how-it-works__content text-left section-space--mb_60">
                        <h3 class="section-title font-weight--light mb-15 wow move-up">How it works</h3>
                        <div class="text mb-20 wow move-up">We design powerful websites & apps for landing your success.</div>
                        <ul class="check-list green-check-list section-space--mb_50 wow move-up">
                            <li class="list-item">Receive real-time business analytics </li>
                            <li class="list-item">Cross-browser Compatible Design </li>
                            <li class="list-item">Completely Gutenberg Ready </li>
                            <li class="list-item">Highly Responsive Tools </li>
                        </ul>
                        <h6 class="sub-heading wow move-up">What’s next in AeroLand? <a href="#" class="hover-style-link hover-style-link--green">Learn more</a></h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FeatureAgency',
    };
</script>